import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { SalesStatistics } from "interface/sales";
import { GrideDateFormatter } from "ui/Date";
import { formatAmount } from "utils/formatters"
import { formatWeight } from "utils/formatters"

interface SalesStatisticsMobileListProps {
	items: SalesStatistics[];
	loading: boolean;
}

const formatVessel = (item: SalesStatistics) => {
	const registration = item.vesselRegistrationNumber?.trim();
	const vesselName = item.vesselDescription?.trim();

	if (registration && vesselName) {
		return `${registration} - ${vesselName}`;
	}

	return registration || vesselName || "-";
};

const SalesStatisticsMobileList: FC<SalesStatisticsMobileListProps> = ({
	items,
	loading,
}) => {
	const { t } = useTranslation();
	const empty = !loading && items.length === 0;

	return (
		<div className="sales-statistics-list-mobile">
			{empty && (
				<div className="sales-statistics-list-mobile-empty">{t("NoRows")}</div>
			)}

			{items.map((item, itemIndex) => {
				const itemKey = `${item.contractNoteNumber || "nocontract"}-${item.landingNoteNumber || "nolanding"}-${item.lineNumber || itemIndex}-${itemIndex}`;

				return (
					<div key={itemKey} className="sales-statistics-list-card">
						<div className="sales-statistics-list-card-header">
							<div className="sales-statistics-list-card-vessel">
								{item.productDescription || "-"}
							</div>
						</div>

						<div className="sales-statistics-list-card-body">
							<div className="sales-statistics-list-card-body-full">
								<span>{t("Vessel")}</span>
								<strong>{formatVessel(item)}</strong>
							</div>
							<div className="sales-statistics-list-card-body-full">
								<span>{t("Buyer")}</span>
								<strong>{item.buyerDescription || "-"}</strong>
							</div>
							<div>
								<span>{t("Species")}</span>
								<strong>{item.specieDescription || "-"}</strong>
							</div>
							<div>
								<span>{t("FishingGear")}</span>
								<strong>{item.fishingGearDescription || "-"}</strong>
							</div>
							<div className="sales-statistics-list-card-body-full">
								<span>{t("CatchArea")}</span>
								<strong>
									{item.catchAreaDescription || item.catchAreaCode || "-"}
									{item.catchAreaZone ? ` / ${item.catchAreaZone}` : ""}
								</strong>
							</div>
							<div>
								<span>{t("PreservationType")}</span>
								<strong>{item.productPreservationType || "-"}</strong>
							</div>
							<div>
								<span>{t("SalesDate")}</span>
								<strong>
									<GrideDateFormatter
										date={item.salesDateTime}
										formatType="dd.MM.yyyy"
										noTd={true}
									/>
								</strong>
							</div>
						</div>

						<div className="sales-statistics-list-card-footer">
							<div>
								<span>{t("GrossWeight")}</span>
								<strong>{formatWeight(item.grossWeight)}</strong>
							</div>
							<div>
								<span>{t("Price")}</span>
								<strong>{formatAmount(item.buyerPrice)}</strong>
							</div>
							<div>
								<span>{t("Value")}</span>
								<strong>{formatAmount(item.buyerValue)}</strong>
							</div>
						</div>
					</div>
				);
			})}

			{loading && (
				<div className="sales-statistics-list-mobile-loading">{t("Loading")}</div>
			)}
		</div>
	);
};

export default SalesStatisticsMobileList;